// Delte hjælpefunktioner til OS-paneler

/**
 * Beregner sparkline-data fra aktivitetsrækker.
 * Input: aktivitet?.aktivitet array med { dato, haendelser }
 * Output: array med { label, vaerdi } klar til SparklineChart
 */
export function beregnSparklineData(aktivitet) {
  const raekker = aktivitet?.aktivitet;
  if (!Array.isArray(raekker) || raekker.length < 2) return null;
  return [...raekker]
    .sort((a, b) => new Date(a.dato) - new Date(b.dato))
    .map(r => ({ label: r.dato ? new Date(r.dato).toLocaleDateString('da-DK', { day: 'numeric', month: 'short' }) : '', værdi: parseInt(r.haendelser) || 0 }));
}
